module.exports = __webpack_public_path__ + "static/media/product-manufacturing-mobile-1.3ee0bf30.png";